import React from 'react'

import { number, oneOfType, string } from 'prop-types'

import formatPlanPrice from '../../Utils/formatPlanPrice'
import { subscriptionPlanShape } from '../../Utils/propTypes'
import translatePlansRestructure from '../../Utils/translatePlansRestructure'

function SubscriptionValueLine({ plan = null, downloadsPerMonth, productPrice = null }) {
  const valueLine = translatePlansRestructure('value_line', {
    monthlyPrice: formatPlanPrice(plan?.monthlyPrice),
    downloads: downloadsPerMonth,
    price: formatPlanPrice(productPrice),
  })
  const text = plan?.isUpgrade ? `${valueLine} ${translatePlansRestructure('upgrade_allowance_credited')}` : valueLine

  return <p className="pricing-area__subscription-value cgt-caption">{text}</p>
}

SubscriptionValueLine.propTypes = {
  plan: subscriptionPlanShape,
  downloadsPerMonth: number.isRequired,
  productPrice: oneOfType([number, string]),
}

export default SubscriptionValueLine
